// extracted by mini-css-extract-plugin
module.exports = {"numberEntry":"numberEntry_numberEntry__3N1Kh","w25":"numberEntry_w25__1QyK2","w50":"numberEntry_w50__2HLTk","w75":"numberEntry_w75__2sFed"};